import { useToast } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';
import * as UsersApi from '@Modules/admin/users/api/UsersApi';
import BankAssociationFormMeta from './BankAssociationFormMeta';
import BankAssociationFormUI from '@Modules/admin/basicSettings/components/formsUI/bank/BankAssociationFormUI';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';

export default function BankAssociationFormHandle() {
  const toast = useToast();
  const { isLoading } = useMutation(UsersApi.createProfile, {
    onSuccess: (data) => {
      console.log('Response: ', data);
      toast({
        position: 'top-right',
        title: 'effectué avec succès',
        isClosable: true,
        status: 'success',
      });
    },
    onError: (error) => {
      console.log('Error: ', error);
    },
  });

  const onSubmit = (payload: any) => {
    console.log('payload: ', payload);
  };

  return (
    <>
      <CC.Text mb="10" fontSize={20} fontWeight="bold">
        Association Par Banque
      </CC.Text>

      <BankAssociationFormUI
        isLoading={isLoading}
        meta={BankAssociationFormMeta}
        onSubmit={onSubmit}
      />

      <CC.Divider my="10" />

      <BankAssociationFormUI
        isLoading={isLoading}
        meta={BankAssociationFormMeta}
        onSubmit={onSubmit}
      />

      <CC.Divider my="10" />

      <BankAssociationFormUI
        isLoading={isLoading}
        meta={BankAssociationFormMeta}
        onSubmit={onSubmit}
      />
    </>
  );
}
